module.exports = __webpack_public_path__ + "static/carousel-hero-web-2x-8b5da267e422cc55400ec6ab2ea3c76f.png";